var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v(" Hello world. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }